export const ru = {
    select: 'Выбрать',
    'zoom-in-button-text': 'Увеличить'
};
